module.exports = __webpack_public_path__ + "cbbd22ff0a86f45107cab7eb78af7e18.jpg";